<template>
  <v-card class="main-content-card" flat >
    <v-toolbar flat>
      <v-toolbar-title>绩效成果登记类型管理</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn color="primary" class="ml-3" @click.native.stop="onNew">新建</v-btn>
      <v-spacer/>
      <v-text-field
        label="按名称检索…"
        v-model="searchName"
        v-on:keyup.enter="onSearchName"
        append-icon="search"
        :append-icon-cb="onSearchName"
      />
    </v-toolbar>
    <v-divider/>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :total-items="total"
      :pagination.sync="pagination"
      item-key="dbid"
      :items="items"
      rows-per-page-text="每页记录数"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{ props.item.name }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="onEdit(props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="onConfirmDel(props.item)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <v-dialog v-model="editDialog" max-width="700px" persistent>
      <v-card>
        <v-form v-model="editDialogValid" ref="editDialogRef" lazy-validation>
          <v-card-title>
            <span class="subheading">{{editFormTitle}}</span>
          </v-card-title>
          <v-progress-linear :indeterminate="true" height="2" v-if="editDialogLoading"/>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs10>
                  <v-text-field label="成果登记类型名称" required :rules="rules.name" v-model="editItem.name"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="blue darken-1" flat @click.native="editDialog = false">取消</v-btn>
            <v-btn color="primary" @click.native="onSave">保存
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>确定要删除该条目吗？</span>
        </v-card-title>
        <v-card-text class="headline">
          {{delMessage}}
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click.stop="delDialog=false">取消</v-btn>
          <v-btn color="primary" flat @click.stop="onDel">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>
<script>
  export default {
    data() {
      return {
        baseURI: '/api/perf/registrationLevel/',
        searchName: '',
        loading: false,
        total: 0,
        items: [],

        // 检索条件
        filters: {
          name: '',
        },

        // 分页条件
        pagination: {
          page: 1,
          rowsPerPage: 25,
          sortBy: 'code.asc'
        },

        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '成果登记类型名称', align: 'left', sortable: true, value: 'name'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid'}
        ],

        // 新建/编辑对话框
        editDialog: false,
        editDialogValid: true,
        editDialogLoading: false,

        editIndex: -1,
        editDbid: null,
        editItem: null,
        defaultItem: null,
        freshItem: {
          "name": ""
        },

        /**
         * 验证规则
         */
        rules: {
          name: [
            v => !!v || '必填项。',
            v => (v && v.length <= 255) || '长度必须小于255个字符。'
          ]
        },

        // 删除对话框
        delDialog: false,
        delDialogLoading: false,

        delIndex: -1,
        delDbid: null,
        delMessage: ''
      }
    },

    created() {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了

      // 复制默认的数据
      this.editItem = window.xutil.clone(this.freshItem)
    },

    watch: {
      // 如果路由有变化，则重新加载数据
      '$route': 'get',

      // 如果分页或排序有变化，则重新加载数据
      pagination: {handler: 'get', deep: true},
      // "pagination.page": 'get',
      // "pagination.rowsPerPage": 'get',
      // "pagination.sortBy": 'get',

      filters: {
        deep: true,
        handler: function () {
          if (this.pagination.page !== 0) {
            this.pagination.page = 0;
          } else {
            this.get();
          }
        }
      }
    },

    computed: {
      editFormTitle() {
        return this.editIndex === -1 ? '新建' : '编辑'
      }
    },

    methods: {
      remote(item, queryText, itemText) {
        // 用于远下拉框的过滤，所以所有选都是显示在下拉框中
        return true;
      },

      /**
       * **************************************************************
       * 事件响应函数
       */

      // 检索响应函数
      onSearchName() {
        this.filters.name = this.searchName
      },
      // 新建响应函数
      onNew() {
        this.$refs.editDialogRef.reset();
        this.editIndex = -1;
        this.editDbid = null;
        this.editItem = window.xutil.clone(this.freshItem);
        this.editDialog = true
      },

      // 编辑响应函数
      onEdit(item) {
        this.$refs.editDialogRef.reset();
        this.editIndex = this.items.indexOf(item);
        this.editDbid = item.dbid;
        this.editDialog = true;

        const vm = this;
        this.axios.get(this.baseURI + this.editDbid)
          .then(rsp => {
            const it = rsp.data;
            // 填充编辑对话框
            vm.editItem = it;

            // 保存默认数据
            vm.defaultItem = window.xutil.clone(this.editItem);
          });
      },

      // 保存响应函数
      onSave() {
        const vm = this;
        if (this.$refs.editDialogRef.validate()) {
          // 新建
          if (this.editIndex < 0) {
            // 以 POST 方式创建新记录
            this.axios.post(this.baseURI, this.editItem)
              .then(rsp => {
                vm.items.unshift(rsp.data);
                vm.total = vm.total + 1;
                vm.editDialog = false;
              })
          }
          //保存
          else {
            // 获取修改的字段
            const changes = window.xutil.changes(this.defaultItem, this.editItem);

            // 有修改的字段，以 PUT 方式保存修改
            if (Object.keys(changes).length > 0) {
              this.axios.put(this.baseURI + this.editDbid, changes)
                .then(rsp => {
                  vm.items[vm.editIndex] = rsp.data;
                  vm.editDialog = false;
                });
            }
            // 关闭对话框
            else {
              this.editDialog = false;
            }
          }
        }
      },

      // 确认删除响应函数
      onConfirmDel(item) {
        this.delMessage = item.name;
        this.delDbid = item.dbid;
        this.delIndex = this.items.indexOf(item);
        this.delDialog = true;
      },

      // 删除响应函数
      onDel() {
        const vm = this;
        vm.delDialogLoading = true;
        this.axios.delete(this.baseURI + vm.delDbid)
          .then(rsp => {
            vm.delDialogLoading = false;
            vm.items.splice(vm.delIndex, 1);
            vm.total = this.total - 1;
            vm.delIndex = -1;
            vm.delDialog = false;
          })
      },

      /**
       * **************************************************************
       * 异步请求
       */
      // 获取列表
      get() {
        window.console.log(JSON.stringify(this.query));
        const vm = this;
        const params = Object.assign(
          window.xutil.paramsPagination(vm.pagination),
          window.xutil.paramsFilters(vm.filters)
        );
        vm.loading = true;
        this.axios.get(vm.baseURI, {params: params})
          .then(rsp => {
            vm.loading = false;
            vm.items = rsp.data.items;
            vm.total = rsp.data.total;
          })
      }
    }
  }
</script>
